






























import ScrollGuide from '@/components/modules/drills/atoms/ScrollGuide.vue'
import TooltipButton from '@/components/modules/drills/atoms/TooltipButton.vue'
import { Component, Prop, Mixins } from 'vue-property-decorator'
import ZoomImage from '@/mixins/aligned/ZoomImage'
@Component({
  components: {
    ScrollGuide,
    TooltipButton,
  },
})
export default class QuestionImageHorizontalV3 extends Mixins(ZoomImage) {
  @Prop({ default: { title: '', url: [], questionCode: '', urlD: [] } })
  dataI?: { title: string; url: string[]; questionCode: string; urlD: string[] }

  @Prop()
  sijiUrl?: string

  @Prop()
  answerUrl?: string[]

  @Prop({ default: false })
  isHiddenQuestion?: boolean

  @Prop({ default: false })
  isHiddenAnswer?: boolean

  @Prop()
  subjectCode!: string

  @Prop({ default: false })
  showZoom!: boolean

  private isAligned = this.$route.query.type === 'aligned'

  private get getDisplayTitle() {
    if (this.isAligned) return this.dataI?.title.split('-')[1]
    return this.dataI?.title
  }

  private get checkDisplaySji() {
    return this.sijiUrl?.length
  }

  private get checkDisplayAnswer() {
    return this.answerUrl?.length
  }
  private get checkDisplayDFrame() {
    return !!this.dataI?.urlD?.length
  }

  private get imageQuestions() {
    return this.dataI?.url
  }

  private get imagesD() {
    return this.dataI?.urlD
  }

  private get checkSubjectCodeKo() {
    return `questions__frameContent ${
      this.checkDisplayDFrame
        ? 'questions__frameContent--vertical'
        : this.checkIsKoSubject
        ? 'questions__frameContent--verticalNoD'
        : ''
    }`
  }

  private get checkIsKoSubject() {
    return this.subjectCode === 'ko'
  }
}
